module.exports = __webpack_public_path__ + "img/user-default.0f8e789e.jpeg";